import type {ReactElement} from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import type {ConfirmationPanelProps} from '@Panels/confirmation-panel/confirmation-panel.types';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import {CONFIRMATION_DIALOG_MODAL_BORDER_RADIUS, CONFIRMATION_DIALOG_MODAL_WIDTH} from '@Components/confirmation-dialog-layout/confirmation-dialog-layout.types';
import {useAppSelector} from '@/hooks';

const PANEL_ID = 'confirmation-modal-panel';

export type ConfirmationModalProps = ConfirmationPanelProps;

export default function ConfirmationModal(): ReactElement<any> {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.CONFIRMATION_MODAL];
  });

  return (
    <Modal
      modalId={MODALS_IDS.CONFIRMATION_MODAL}
      panelId={PANEL_ID}
      modalHeight="auto"
      modalWidth={CONFIRMATION_DIALOG_MODAL_WIDTH}
      modalMaxWidth="100%"
      modalBorderRadius={CONFIRMATION_DIALOG_MODAL_BORDER_RADIUS}
    >
      <LazyPanel
        panelDirectoryName="confirmation-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openConfirmationModal = (props: ConfirmationModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CONFIRMATION_MODAL,
      panelProps: props,
    })
  );
};
